module.exports = __webpack_public_path__ + "static/media/cover-image-bicc.6a929eac.jpg";